import { render, staticRenderFns } from "./DataBmi.vue?vue&type=template&id=5c53c483&"
import script from "./DataBmi.vue?vue&type=script&lang=js&"
export * from "./DataBmi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports